import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { deleteAProduct, getProducts, resetState } from "../features/product/productSlice";
import { Link } from "react-router-dom";
import CustomModal from "../components/CustomModal";
const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title:"Image",
    dataIndex:"images",
    render: (text) => <img src={text} alt="Product" style={{ width: 50 }} />,
    width: 80,

  },
  {
    title: "Title",
    dataIndex: "title",
    sorter: (a, b) => a.title.length - b.title.length,
    width: 300,
  },

  {
    title: "Type",
    dataIndex: "type",
    sorter: (a, b) => a.category.length - b.category.length,
  },

  {
    title: "Price",
    dataIndex: "price",
    sorter: (a, b) => a.price - b.price,
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const Productlist = () => {
  const [open, setOpen] = useState(false);
  const [productSlug, setproductSlug] = useState("");
   const showModal = (slug) => {
    setOpen(true);
    setproductSlug(slug);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getProducts());
  }, []);
  const productState = useSelector((state) => state.product.products);
   const data1 = [];
  for (let i = 0; i < productState.length; i++) {
    const imageUrl = productState[i].images[0]?.url;
  
  
  
    // Add the product data to the table
    data1.push({
      key: i + 1,
      images: imageUrl,
      title: productState[i].title,
      type: productState[i].type,
      price: `KES ${productState[i].price.toLocaleString()}`, 
      action: (
        <>
          <Link to={`/admin/vehicle/${productState[i].slug}`} className="fs-3 text-danger">
            <BiEdit />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(productState[i].slug)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }
  
  
  const deleteProduct = (productSlug) => {
    dispatch(deleteAProduct(productSlug));

    setOpen(false);
    setTimeout(() => {
      dispatch(getProducts());
    }, 100);
  };
  return (
    <div>
      <h3 className="mb-4 title">Cars</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteProduct(productSlug);
        }}
        title="Are you sure you want to delete this product?"
      />
    </div>
  );
};


export default Productlist;
